var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck400Rounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.4,
    height: 11.2,
    viewBox: "0 0 15.4 11.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-check-400-rounded",
    d: "M8.8,17.3,4.6,13a.967.967,0,0,1,0-1.4h0a.967.967,0,0,1,1.4,0L9.4,15a.187.187,0,0,0,.3,0L18,6.7a.967.967,0,0,1,1.4,0h0a.967.967,0,0,1,0,1.4l-9.2,9.2A.965.965,0,0,1,8.8,17.3Z",
    transform: "translate(-4.3 -6.4)",
    fill: "#009bde"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck400Rounded);
export default __webpack_public_path__ + "static/media/icon-check-400-rounded.f1aebb5eb37ce8b95b21438b212e8be6.svg";
export { ForwardRef as ReactComponent };